import { AxiosError } from 'axios'
import { showMessage } from './showMessage'

export const showServerError = (e?: unknown) => {
  if (e) {
    const error = e as AxiosError<{ message: string }>
    if (error.status === 401 || error.status === 403) return
    const message = error.response?.data?.message
    // Причины, по которым товар нельзя опубликовать, бэкенд присылает списком по строкам
    const isList = !!message?.includes('\n')
    return showMessage(
      'error',
      isList ? (
        <span style={{ whiteSpace: 'pre-line' }}>{message}</span>
      ) : (
        message ?? 'Ошибка на сервере'
      ),
      message
        ? ''
        : 'Попробуйте отправить запрос еще раз, либо немного позднее',
      isList ? 15 : undefined
    )
  }
  return showMessage(
    'error',
    'Ошибка на сервере',
    'Попробуйте отправить запрос еще раз, либо немного позднее'
  )
}
